import filter from 'lodash/fp/filter'
import find from 'lodash/fp/find'
import map from 'lodash/fp/map'
import over from 'lodash/fp/over'
import pipe from 'lodash/fp/pipe'
import prop from 'lodash/fp/prop'
import some from 'lodash/fp/some'
import fromPairs from 'lodash/fromPairs'
import get from 'lodash/get'
import toPairs from 'lodash/toPairs'
import * as Elasticsearch from '../../../elasticsearch'
import * as CommunityConfig from '../../community-config'

type SeriesName = string
interface Bucket extends Elasticsearch.Bucket {
  [index: string]: any,
  unique_count: {
    value: number,
  }
}
export const bucketSelector = (seriesName: SeriesName) => pipe(
  Elasticsearch.selectAggs,
  prop(Elasticsearch.DocumentFieldNames.EventName),
  Elasticsearch.selectBuckets,
  find((bucket: Bucket) => bucket.key === seriesName),
  prop(Elasticsearch.AggFieldNames.TotalCount),
  Elasticsearch.selectBuckets,
)
export const selectByTimeBucket = (seriesName: SeriesName) => pipe(
  bucketSelector(seriesName),
  map((bucket: Bucket) => [
    bucket.key_as_string,
    {
      totalCount: bucket.doc_count,
      uniqueCount: bucket[Elasticsearch.AggFieldNames.UniqueCount].value,
    },
  ]),
)
export const selectDelivered = selectByTimeBucket(Elasticsearch.EmailActionFieldSegments.Delievered)
export const selectClicks = selectByTimeBucket(Elasticsearch.EmailActionFieldSegments.Click)
export const selectOpens = selectByTimeBucket(Elasticsearch.EmailActionFieldSegments.Open)
export const getCategories = pipe(
  selectDelivered,
  filter(([keyAsString, counts]) => some(([key, value]) => value > 0, toPairs(counts))),
  map(([keyAsString]) => keyAsString),
)
export interface Percentage {
  timestamp: string,
  values: number,
}
export interface AsPercentArgs {
  denominator: string,
  numerator: string,
}
export const asPercentage: any = ({numerator, denominator}: AsPercentArgs) => pipe(
  over([
    getCategories,
    pipe(
      selectByTimeBucket(numerator),
      fromPairs,
    ),
    pipe(
      selectByTimeBucket(denominator),
      fromPairs,
    ),
  ]),
  ([timeBuckets, numeratorMap, denominatorMap]) =>
    timeBuckets.map((timeBucket: string) => ({
      deliveredCount: get(denominatorMap[timeBucket], 'totalCount', 0),
      timestamp: timeBucket,
      totalCount: get(numeratorMap[timeBucket], 'totalCount', 0),
      totalPercentage: get(denominatorMap[timeBucket], 'totalCount', 0) === 0 ? 0 :
        (
          get(numeratorMap[timeBucket], 'totalCount', 0)
          /
          denominatorMap[timeBucket].totalCount
        ) * 100,
      uniqueCount: get(numeratorMap[timeBucket], 'uniqueCount', 0),
      uniquePercentage: get(denominatorMap[timeBucket], 'uniqueCount', 0) === 0 ? 0 :
        (
          get(numeratorMap[timeBucket], 'uniqueCount', 0)
          /
          denominatorMap[timeBucket].uniqueCount
        ) * 100,
    })))

export const selectEngagmentDefault = pipe(
  prop('payload.response.configs'),
  find((config: CommunityConfig.ConfigRow) => config.key === 'engagement_report_default_view'),
  prop('value'),
)



// WEBPACK FOOTER //
// ./src/pages/reports/analytics/utils.ts